import { z } from 'zod';

import { CmsUrl } from '../models';
import { BasePType } from './base';

export const SubFooterLink = BasePType.extend({
  type: z.enum(['subFooterLink']),
  aTarget: z.string().nullable(),
  anchorTarget: z.string().nullable(),
  padding: z.string().nullable(),
  paddingBottom: z.string().nullable(),
  paddingHorizontal: z.string().nullable(),
  paddingLeft: z.string().nullable(),
  paddingRight: z.string().nullable(),
  paddingTop: z.string().nullable(),
  paddingVertical: z.string().nullable(),
  url: CmsUrl,
});

export type SubFooterLink = z.infer<typeof SubFooterLink>;
